// React
import React from "react";
import { AppTopNav } from "app/application/ui/navBars/AppTopNav";
import NotificationView from "app/application/ui/NotificationView";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./AppFrame.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export const AppFrame = (props) => {
    return (React.createElement("div", { className: styles.appContainer },
        React.createElement(AppTopNav, null),
        props.children,
        React.createElement(NotificationView, null)));
};
